import type { GeoJSON } from "geojson";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui";
import { canEditRouteGeoJson } from "~/features/recordGeoItems/utils/routeEditorGeoJson";

export function RouteEditorActions({ geometry, onStart }: { geometry: GeoJSON | null; onStart: () => void }) {
  const { t } = useTranslation();
  if (!canEditRouteGeoJson(geometry)) {
    return <p className="text-12-medium text-fg-3">{t("feature.recordGeoItems.routeEditor.unsupportedGeometry")}</p>;
  }

  return (
    <Button type="button" variant="outline" size="sm" onClick={onStart}>
      {t("feature.recordGeoItems.routeEditor.returnToMapEditing")}
    </Button>
  );
}
